exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.job-tbl .b-table-sticky-header[data-v-4d229cee] {\n    max-height: 500px;\n}\n", ""]);

// exports
